import { createFileRoute, redirect } from '@tanstack/react-router'

// The legacy "Doc Style" page here used to edit a DocTemplate row, which is the
// wrong model for taste/voice (and is now read-only for built-ins). Taste/voice
// lives in Writing settings, so redirect any old links/bookmarks there.
export const Route = createFileRoute('/(protected)/settings/templates')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/writing' })
  },
})
